import React from 'react'

import { cn } from './utils'
import { Lens } from '../lens'

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string
  withLens?: boolean
}

const Image: React.FC<ImageProps> = ({
  className,
  alt,
  withLens = false,
  ...props
}) => {
  return (
    <>
      {withLens ? (
        <Lens zoomFactor={2.5} lensSize={260}>
          <img
            className={cn('max-w-full h-auto', className)}
            alt={alt || 'Image'}
            {...props}
          />
        </Lens>
      ) : (
        <img
          className={cn('max-w-full h-auto', className)}
          alt={alt || 'Image'}
          {...props}
        />
      )}
    </>
  )
}

export { Image }
